import type { FaireProductEntity } from "../../entity_types/product";

export const p_8tswrp9vhr: FaireProductEntity = {
  token: "p_8tswrp9vhr",
  type: "product",
  name: "Drama Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/ed24effccd9b858125851506b37b3793c33a7fdf9b9d273d7d340709a1401f4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb12a2b80abc17b45ecb7349c2a72c972eb6d066318145c5a3d0e8827737f95d.jpeg",
    "https://cdn.faire.com/fastly/1c438849ea73ff67ab5759135e9b35cc4b60c159f193d3f2bf0f6372e4f72c0f.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/d901c9c358cf11ced1f62aeba0fab9dd246de2e28056d74d2cffa07e8f48fe11.jpeg",
    "https://cdn.faire.com/fastly/649cbfeab13c5d5832b59c86af3e566b29bdaec675ca6c3c519beec2f1038c3c.jpeg"
  ],
  priceDollars: 6.75,
  description: "Always a little extra, even when nothing is happening yet.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:27.455Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
